import React, { FC } from 'react';
import { Box, Grid, Radio, Typography } from '@mui/material';
import { isEmpty } from 'lodash';
import { ModalAnswerRow } from 'pages/Funds/components/ProcessManagement/ModalAnswerRow';
import theme from 'theme';
import { AnswerProgressItemProps } from './types';
import { AnsweredAt } from '../AnsweredAt';

const AnswerProgressItem: FC<AnswerProgressItemProps> = props => {
  const { task } = props;
  const { name: taskName, answers: taskAnswers } = task;
  const isTaskAnswered = !isEmpty(taskAnswers)
    ? taskAnswers?.some(answer => Boolean(answer?.date_answer ?? answer?.selected_choice ?? answer?.text_answer))
    : false;
  const lastAnswer = taskAnswers?.[taskAnswers.length - 1];
  return (
    <Box
      border={`1px solid ${theme.palette.grey?.[300]}`}
      borderRadius="0.25rem"
      bgcolor={theme.palette.grey?.[100]}
      padding="1rem"
      marginBottom="1rem">
      <Grid container spacing={1} alignItems="flex-start">
        <Grid item xs={1}>
          <Radio checked={isTaskAnswered} style={{ pointerEvents: 'none', padding: 0 }} />
        </Grid>
        <Grid item xs={11}>
          <Typography style={{ fontWeight: 700, color: theme.palette.black, fontSize: '1rem', display: 'inline' }}>
            {taskName}{' '}
          </Typography>
          <ModalAnswerRow task={task} />
        </Grid>
        {isTaskAnswered && lastAnswer && (
          <Grid item xs={12} style={{ display: 'flex', justifyContent: 'flex-end' }}>
            <AnsweredAt date={lastAnswer.updated_at} />
          </Grid>
        )}
      </Grid>
    </Box>
  );
};

export default AnswerProgressItem;
